import React from 'react';
import useMileageSafeDriving, {SafeDrivingChallengeType} from '@di-shared/features/mileage/safedriving/useMileageSafeDriving';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

interface HomeMileageInnerContentsSafeDrivingKrProps {
  vin: string;
}

function HomeMileageInnerContentsSafeDrivingKr({vin}: HomeMileageInnerContentsSafeDrivingKrProps) {
  const {t} = useInferableTranslation();
  const {safeDrivingChallengeType} = useMileageSafeDriving(vin);

  function getSafeDrivingMileageText(safeDrivingChallengeType: SafeDrivingChallengeType) {
    switch (safeDrivingChallengeType) {
      case SafeDrivingChallengeType.FIVE_THOUSAND:
        return t('T30167');
      case SafeDrivingChallengeType.THREE_THOUSAND:
        return t('T30356');
      case SafeDrivingChallengeType.INSUFFICIENT_SCORE:
        return t('T10134');
      case SafeDrivingChallengeType.INSUFFICIENT_ODOMETER:
        return t('T10135');
      default:
        return t('T30357');
    }
  }

  return (
    <li className="eco_state_item">
      <strong className="eco_state_title">{t('T10127')}</strong>
      <p className="eco_state_desc">{getSafeDrivingMileageText(safeDrivingChallengeType)}</p>
      <div className="badge_box">
        <span className="badge badge_basic_container badge_20px">{t('T10126')}</span>
      </div>
    </li>
  );
}

export default HomeMileageInnerContentsSafeDrivingKr;

export function HomeMileageInnerContentsSafeDrivingError() {
  const {t} = useInferableTranslation();
  return (
    <li className="eco_state_item">
      <strong className="eco_state_title">{t('T10127')}</strong>
      <p className="eco_state_desc">{t('T10136')}</p>
      <div className="badge_box">
        <span className="badge badge_basic_container badge_20px">{t('T10126')}</span>
      </div>
    </li>
  );
}
